import { StyleSheet } from 'aphrodite/no-important';

import spacing from '../../identity/spacing';

const fadeInUp = {
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
};

export default StyleSheet.create({
  mediaContainer: {
    height: 0,
    position: 'relative',
    backgroundColor: '#fff',

    ...spacing.M_B_XS,
  },

  media: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 0,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'none',
    transform: 'translate3d(0, 0, 0)',
  },

  animate: {
    animationName: fadeInUp,
    animationDuration: '1s',
    animationFillMode: 'forwards',
    animationTimingFunction: 'cubic-bezier(0.1, 0.7, 1.0, 0.1',
  },

  no_margin: {
    margin: '0 !important',
  },
});



// WEBPACK FOOTER //
// ./src/components/Media/style.js